import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const DutiesAndTaxes = {
  id: 'duties-and-taxes',
  name: BulkActions.dutiesAndTaxes.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.dutiesAndTaxes], ids, GuidService.newGuid(), filters));
  },
};
